<template>
  <div class="flex flex-col gap-4">
    <!-- Loading state -->
    <div
      v-if="isLoadingUsers && users.length === 0"
      class="flex justify-center py-4"
    >
      <LoadingIndicator :loading="isLoadingUsers" />
    </div>

    <!-- No users -->
    <div v-else-if="users.length === 0" class="text-gray-500 text-center py-4">
      No users with click tracking data found
    </div>

    <!-- Users list -->
    <template v-else>
      <div class="flex flex-col gap-2">
        <div
          v-for="user in users"
          :key="user.userId"
          class="p-4 bg-white rounded-lg shadow cursor-pointer hover:shadow-md transition-shadow"
          :class="{
            'border-2 border-blue-500': selectedUserId === user.userId,
          }"
          @click="selectUser(user.userId)"
        >
          <div class="flex items-center justify-between">
            <div class="flex flex-col">
              <div class="font-medium">{{ user.userEmail }}</div>
              <div class="text-sm text-gray-500">
                Last active: {{ new Date(user.lastActive).toLocaleString() }}
              </div>
            </div>
            <div v-if="selectedUserId === user.userId" class="text-blue-500">
              ●
            </div>
          </div>
        </div>
      </div>

      <!-- Load more button -->
      <button
        v-if="hasMoreUsers"
        @click="$emit('load-more')"
        class="mt-2 w-full py-2 px-4 text-center text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded transition-colors"
        :disabled="isLoadingUsers"
      >
        {{ isLoadingUsers ? "Loading..." : "Load more users" }}
      </button>
    </template>
  </div>
</template>

<script setup>
import { computed } from "vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import { useAnalytics } from "@/stores";

const analyticsStore = useAnalytics();

const props = defineProps({
  users: {
    type: Array,
    required: true,
  },
  isLoadingUsers: {
    type: Boolean,
    default: false,
  },
  hasMoreUsers: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["load-more"]);

// Computed properties from store
const selectedUserId = computed(() => analyticsStore.selectedUserId);

// Methods
const selectUser = async (userId) => {
  if (selectedUserId.value !== userId) {
    await analyticsStore.selectUser(userId);
  }
};
</script>
